// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2485":"56deee5e215d5431","4399":"7e364b29bd1c6256","4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","6572":"ae9523db883078f0","7153":"78ae11373932669b","9410":"42b3d2f42126ef39","9700":"d3dc3f3c1c42f3ca"}[chunkId] + ".css";
};